import { useTrackEvent } from "@outschool/ui-analytics";

import { hasSubcategories } from "./categoryNavbarUtils";
import { CategoryNavLink } from "./navbarCategories";

export const CATEGORY_NAVBAR_COMPONENT = {
  BROWSE_MENU: "browse-menu",
  HORIZONTAL_NAVBAR: "horizontal-navbar",
} as const;

export type CategoryNavbarComponent =
  (typeof CATEGORY_NAVBAR_COMPONENT)[keyof typeof CATEGORY_NAVBAR_COMPONENT];

export function buildCategoryTrackingProperties(
  category: CategoryNavLink,
  options?: {
    component?: CategoryNavbarComponent;
    ancestors?: CategoryNavLink[];
  },
): Record<string, any> {
  const properties: Record<string, any> = {
    category: category.slug,
  };

  if (options?.component) {
    properties.component = options.component;
  }

  if (options?.ancestors && options.ancestors.length > 0) {
    properties.ancestors = options.ancestors.map(ancestor => ancestor.slug);
  }

  return properties;
}

export function trackSubmenuOpen(
  trackEvent: ReturnType<typeof useTrackEvent>,
  category: CategoryNavLink,
  options?: {
    component?: CategoryNavbarComponent;
    ancestors?: CategoryNavLink[];
    wasAlreadySelected?: boolean;
  },
): void {
  if (options?.component && options?.wasAlreadySelected !== undefined) {
    if (!hasSubcategories(category) || options.wasAlreadySelected) {
      return;
    }
  }

  const properties = buildCategoryTrackingProperties(category, options);

  trackEvent("category_navbar_submenu_open", properties);
}
